import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import './stil/grund.css'

import { App } from './App'
import { AnmeldungAnbieter } from './lib/anmeldung'

const abfragen = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})

const wurzel = document.getElementById('app')
if (!wurzel) throw new Error('Der Einhängepunkt #app fehlt.')

createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={abfragen}>
      <BrowserRouter>
        <AnmeldungAnbieter>
          <App />
        </AnmeldungAnbieter>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
